import React, { Suspense, useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import Text from 'components/Text';
import Model from '../../../../model';
import DatetimeField from '../DatetimeField';
import CommonDateTimeInput from '../DatetimeField/CommonDateTimeInput';
import { useMobile } from 'utils/media';
import './index.sass';
import MobileDialogDateTimeField from 'forms/fields/DatetimeField/MobileDialogDateTimeField';
import PopoverDateTimeField from 'forms/fields/DatetimeField/PopoverDateTimeField';
import { eventsData } from 'api/events';

const { block, el } = bem('form-field', 'events-field');

const MobilePopup = (props) => {
    const text = 'Выберите желаемую\nдату и время';
    return <MobileDialogDateTimeField {...props} text={text} />
}

const EventsField = () => {

    return (
        <div className={ block() }>
            <div className={ el('label') }>
                <Text>{`Выберите желаемую\nдату и время`}</Text>
            </div>
            <Suspense fallback={<CommonDateTimeInput loading={true} />}>
                <SuspendedDatetimeField />
            </Suspense>
        </div>
    );
}

const SuspendedDatetimeField = observer(() => {
    eventsData.read();
    const { isMobile } = useMobile();
    const { selectedEvent, setSelectedEvent, events } = Model.orderForm;
    const [ value, setValue ] = useState(selectedEvent);

    useEffect(() => {
        setValue(selectedEvent);
    }, [selectedEvent])

    const setExtValue = (value) => {
        if (value) {
            setSelectedEvent(value);
        }
    }

    return <DatetimeField name={ 'datetime-field' } setValue={ setExtValue } Input={ CommonDateTimeInput }
                            Popup={ isMobile ? MobilePopup : PopoverDateTimeField }
                            utcDates={ events } value={ value } />
})

export default observer(EventsField);
